import {
	SURVEY_LOADING_TRUE,
	SURVEY_LOADING_FALSE,
	SURVEY_RESPONSE_GET,
	SURVEY_RESPONSE_ERROR,
	SURVEY_SCHEMAS_GET,
	SURVEY_SCHEMAS_ERROR,
	SURVEY_SCHEMA_DISPLAY_GET,
	SURVEY_SCHEMA_DISPLAY_ERROR,
	SURVEY_LIST_LOADING,
	SURVEY_LIST_GET,
	SURVEY_LIST_ERROR,
	SURVEY_DAILY_LOADING,
	SURVEY_DAILY_GET,
	SURVEY_DAILY_ERROR,
	SURVEY_LOOKUP_LOADING,
	SURVEY_LOOKUP_GET,
	SURVEY_LOOKUP_ERROR,
	SET_SURVEY_IMAGES
} from '../actions/types';

const initialState = {
	survey_loading: false,
	survey_response: {},
	survey_schemas: {},
	survey_schema_display: [],
	survey_images: [],
	survey_list_loading: false,
	survey_list: { count: 0, responses: [] },
	survey_daily_loading: false,
	survey_daily: { total: 0, days: [] },
	survey_lookup_loading: false,
	survey_lookup: {},
	survey_errors: {}
}

export default function surveyReducer(state = initialState, action) {
	switch (action.type) {
		case SURVEY_LOADING_TRUE:
			return { ...state, survey_loading: true };

		case SURVEY_LOADING_FALSE:
			return { ...state, survey_loading: false };

		case SURVEY_RESPONSE_GET:
			delete state.survey_errors.survey_response;
			return { ...state, survey_response: action.payload };

		case SURVEY_SCHEMAS_GET:
			delete state.survey_errors.survey_schemas;
			return { ...state, survey_schemas: action.payload };

		case SURVEY_SCHEMA_DISPLAY_GET:
			delete state.survey_errors.survey_schema_display;
			return { ...state, survey_schema_display: action.payload };

		case SURVEY_LIST_LOADING:
			return { ...state, survey_list_loading: action.payload };

		case SURVEY_LIST_GET:
			delete state.survey_errors.survey_list;
			return {
				...state,
				survey_list: {
					count: action.payload.count,
					responses: action.payload.responses ?? []
				}
			};

		case SURVEY_DAILY_LOADING:
			return { ...state, survey_daily_loading: action.payload };

		case SURVEY_DAILY_GET:
			delete state.survey_errors.survey_daily;
			return {
				...state,
				survey_daily: {
					total: action.payload.total ?? 0,
					days: Array.isArray(action.payload.days) ? action.payload.days : []
				}
			};

		case SURVEY_LOOKUP_LOADING:
			return { ...state, survey_lookup_loading: action.payload };

		case SURVEY_LOOKUP_GET: {
			const { survey_lookup, ...rest } = state.survey_errors;
			return { ...state, survey_errors: rest, survey_lookup: action.payload };
		}

		case SET_SURVEY_IMAGES:
			return { ...state, survey_images: action.payload };

		case SURVEY_RESPONSE_ERROR:
		case SURVEY_SCHEMAS_ERROR:
		case SURVEY_SCHEMA_DISPLAY_ERROR:
		case SURVEY_LIST_ERROR:
		case SURVEY_DAILY_ERROR:
		case SURVEY_LOOKUP_ERROR:
			return {
				...state,
				survey_errors: {
					...state.survey_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			};

		default:
			return state;
	}
}
